<template>
  <v-col cols="12" sm="12" md="9">
    <div class="calendar-wrapper">
      <div>
        <v-toolbar flat>
          <v-btn-toggle relative>
            <v-btn fab text small color="grey darken-4" @click="$emit('prev')">
              <v-icon small>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
              outlined
              color="darken-2"
              small
              @click="$emit('set-today')"
              min-height="40"
            >
              Today
            </v-btn>
            <v-btn outlined color="grey darken-4" small min-height="40">
              <span v-if="$refs.calendar">
                {{ $refs.calendar.title }}
              </span>
            </v-btn>
            <v-btn fab text small color="grey darken-4" @click="$emit('next')">
              <v-icon small>mdi-chevron-right</v-icon>
            </v-btn>
          </v-btn-toggle>
          <v-spacer></v-spacer>
          <div v-show="!$vuetify.breakpoint.smAndDown">
            <v-btn
              dark
              small
              color="indigo darken-4"
              min-height="40"
              elevation="0"
              class="ml-2"
              @click="$emit('print-events')"
              v-if="!directCareStaff"
            >
              <v-icon small color="white">mdi-printer</v-icon>
              <span color="white">Print Event</span>
            </v-btn>
            <v-btn
              dark
              small
              color="indigo darken-4"
              min-height="40"
              elevation="0"
              class="ml-2"
              @click="$emit('show-add')"
              v-if="!directCareStaff"
            >
              <v-icon small color="white">mdi-plus</v-icon>
              <span color="white">Add Event</span>
            </v-btn>
          </div>
        </v-toolbar>
      </div>

      <v-sheet class="calendar-grid">
        <v-calendar
          ref="calendar"
          v-model="calendarValue"
          :events="events"
          :type="calendarType"
          :event-color="getEventColor"
          :event-ripple="false"
          class="modern-calendar"
          :event-height="69"
          @change="handleCalendarChange"
          @click:event="handleEventClick"
        >
          <template v-slot:event="{ event }">
            <div class="calendar-event">
              <span class="event-time">
                <span>{{ event.startTime }} - {{ event.endTime }}</span>
              </span>
              <span class="event-title">{{ event.name }}</span>
              <span class="event-title">{{ event.event }}</span>
            </div>
          </template>
        </v-calendar>
      </v-sheet>
    </div>
  </v-col>
</template>

<script>
import moment from "moment";

export default {
  name: "CalendarMain",

  props: {
    events: {
      type: Array,
      required: true,
      default: () => [],
    },
    focus: {
      type: String,
      required: true,
    },
    calendarType: {
      type: String,
      required: true,
      validator: (value) => ["month", "week", "day", "4day"].includes(value),
    },
    directCareStaff: {
      type: Boolean,
      default: false,
    },
    calendarDrawer: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    calendarValue: {
      get() {
        return this.focus;
      },
      set(value) {
        this.$emit("update:focus", value);
      },
    },
  },

  methods: {
    getEventColor(event) {
      return event.color;
    },

    formatEventTime(date) {
      return moment(date).format("h:mm A");
    },

    handleCalendarChange(e) {
      if (!e || !e.start || !e.end) return;
      this.$emit("calendar-change", e);
    },

    handleEventClick(e) {
      this.$emit("event-click", e);
    },

    setCalendarDrawer(value) {
      this.$emit("update:calendar-drawer", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.calendar-grid {
  .modern-calendar {
    :deep(.v-calendar-weekly__head-weekday) {
      font-size: 12px;
      font-weight: 600;
      color: #1e293b;
      text-transform: uppercase;
      padding: 12px 8px;
      border-bottom: 1px solid #e2e8f0;
    }

    :deep(.v-calendar-weekly__day) {
      border: 1px solid #e2e8f0;
      min-height: 120px;

      &.v-present {
        background-color: #faf5ff;
      }
    }
  }
}

.calendar-event {
  padding: 1px 8px;
  border-radius: 6px;
  margin: 2px;
  font-size: 12px;
  display: flex;
  flex-direction: column;

  .event-time {
    font-size: 11px;
    opacity: 0.9;
    margin-bottom: 2px;
    font-weight: bold;
  }

  .event-title {
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: bold;
  }
}

.v-toolbar {
  border-bottom: 1px solid #e2e8f0;

  .v-btn-toggle {
    margin: 0 4px;

    .v-btn {
      border-color: #e2e8f0;

      &:not(:last-child) {
        margin-right: 4px;
      }
    }
  }
}

@media (max-width: 600px) {
  .calendar--menu {
    margin-left: auto;
  }
}
</style>
